import Component from './Component';
import normalizeNode from './normalizeNode';
import operations from './operations';
import { deserialize, serialize } from './serialize';
import { type } from './shared';
import slashMenu from './slashMenu';

export default {
  deserialize,
  isVoid: true,
  normalizeNode,
  operations,
  Component,
  serialize,
  slashMenu,
  type,
};
